import {
  RecipeIndex,
  RecipeProductIndex,
  PreparationIndex,
  RecipeProductEditor,
  RecipeEditor,
  RecipeViewer,
  ProductBulkEditor,
  RecipeListViewer,
  RecipeBulkEditor
} from "../views";

export const recipeRouter = {
  main: [
    {
      path: "recipeIndex",
      name: "RecipeIndex",
      component: RecipeIndex
    },
    {
      path: "preparationIndex",
      name: "PreparationIndex",
      component: PreparationIndex
    },
    {
      path: "recipeProductsIndex",
      name: "RecipeProductsIndex",
      component: RecipeProductIndex
    },
    {
      path: "recipeProduct/:id",
      name: "ProductEditor",
      component: RecipeProductEditor,
      props: true
    },
    {
      path: "recipe-product-creation/",
      name: "ProductCreator",
      component: RecipeProductEditor,
      props: true
    },
    {
      path: "recipe-editor/:id",
      name: "RecipeEditor",
      component: RecipeEditor,
      props: true,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: "product/bulk-editor",
      name: "ProductBulkEditor",
      component: ProductBulkEditor,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: "recipe/bulk-editor",
      name: "RecipeBulkEditor",
      component: RecipeBulkEditor,
      meta: {
        requiresAdmin: true
      }
    }
  ],
  viewer: [
    {
      path: "recipe/:id",
      name: "RecipeViewer",
      component: RecipeViewer,
      props: true
    },
    {
      path: "recipe-list",
      name: "RecipeListViewer",
      component: RecipeListViewer,
      props: true
    }
  ]
};
